export default "__VITE_ASSET__B1OTyKv8__"